export var CostManagementSubjects;
(function (CostManagementSubjects) {
    CostManagementSubjects["CostManagementPage"] = "cost-management-page";
    CostManagementSubjects["UsageTable"] = "usage-table";
    CostManagementSubjects["UsageTableEmptyState"] = "usage-table-empty-state";
    CostManagementSubjects["UtsSummary"] = "uts-summary";
    CostManagementSubjects["UtsSummaryAccountTotal"] = "uts-summary-account-total";
    CostManagementSubjects["UtsSummaryFilteredTotal"] = "uts-summary-filtered-total";
})(CostManagementSubjects || (CostManagementSubjects = {}));
export var CostManagementTabs;
(function (CostManagementTabs) {
    CostManagementTabs["Logs"] = "logs";
    CostManagementTabs["Metrics"] = "metrics";
})(CostManagementTabs || (CostManagementTabs = {}));
//# sourceMappingURL=cost-management.enum.js.map